import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyPipe } from './pipe/currency.pipe';
import { AnswerSelectorPipe } from './pipe/answer-selector.pipe';
import { ArraySortPipe } from './pipe/arrayshort.pipe';
import { LockPipe } from './pipe/lock.pipe';
import { ErrorInternetComponent } from './error-internet/error-internet.component';
import { QnavigatorService } from './services/qnavigator.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { ShoppingCartService } from './services/shopping-cart.service'
import { LoginRedirectService } from './services/login-redirect.service';
import { RegistrationFeeService } from './services/registration-fee.service';
import { CommonService } from './services/common-service';
import { InfoPopupComponent } from './popup/info-popup/info-popup.component';
// import {CompetitionPopupComponent} from './popup/competition-popup/competition-popup.component';
import { Competition } from '../core-modules/model';


// import { PaperSetComponent } from '../core-modules/paper-sets/components/paper-set.component';

@NgModule({
  declarations: [
    LockPipe,
    ErrorInternetComponent,
    CurrencyPipe,
    AnswerSelectorPipe,
    ArraySortPipe,
    InfoPopupComponent,
    // CompetitionPopupComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  providers: [QnavigatorService, TranslateService, ShoppingCartService, LoginRedirectService, RegistrationFeeService, CommonService],
  exports: [
    TranslateModule,
    CommonModule,
    CurrencyPipe,
    AnswerSelectorPipe,
    ArraySortPipe,
    InfoPopupComponent,
    // CompetitionPopupComponent
  ],
})
export class SharedModule { }



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/shared.module.ts